import { render, staticRenderFns } from "./CowsNosePunching1.vue?vue&type=template&id=b5180fe0&scoped=true&"
import script from "./CowsNosePunching1.vue?vue&type=script&lang=js&"
export * from "./CowsNosePunching1.vue?vue&type=script&lang=js&"
import style0 from "./CowsNosePunching1.vue?vue&type=style&index=0&id=b5180fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5180fe0",
  null
  
)

export default component.exports